import * as React from "react";
import { Dialog, DialogContent, DialogHeader } from "@components/ui/dialog";
import { Card } from "../ui/card";
import { getAnomalyInfo } from "@services/api/commonApis";
import { useQuery, useQueryClient } from "react-query";
import DialogLoader from "../loaders/DialogLoader";
import { AnomalyDetailProps } from "./CommonTypes";

const AnomalyDetail: React.FC<AnomalyDetailProps> = ({
  anomalyId,
  openState,
  onClose,
}) => {
  const {
    data: anomalydata,
    refetch: refetchAnomalyData,
    isRefetching: isRefetching,
  } = useQuery(["getAnomalyInfo", anomalyId], () => getAnomalyInfo(anomalyId));

  const queryClient = useQueryClient();

  const [solutions, setSolutions] = React.useState([] as any);
  const [description, setDescription] = React.useState([] as any);

  React.useEffect(() => {
    queryClient.invalidateQueries("getAnomalyInfo");
    if (anomalydata && Object.keys(anomalydata).length > 0) {
      const sols = anomalydata.recommended_solution.split("***");
      setSolutions(sols);

      const desc = anomalydata.description.split("***");
      setDescription(desc);
    }
  }, [anomalydata]);

  React.useEffect(() => {
    refetchAnomalyData();
  }, [anomalyId]);

  return (
    <>
      <Dialog open={openState} onOpenChange={onClose}>
        <DialogContent className="max-w-[50vw] max-h-[80vh] overflow-y-scroll">
          <DialogLoader show={isRefetching} />
          <DialogHeader>{anomalydata ? anomalydata.name : ""}</DialogHeader>
          <div className="w-full p-2">
            <Card className="p-4">
              <div className="text-sm font-bold mb-4">Description</div>
              <div className="text-xs">
                {description.map((desc: string, index: number) => {
                  return <p key={index}>{desc}</p>;
                })}
              </div>
            </Card>
            <Card className="p-4 mt-2">
              <div className="text-sm font-bold mb-4">Recommended Solution</div>
              <div className="text-xs">
                <ul>
                  {solutions.map((sol: string, index: number) => {
                    return <li key={index}>{sol}</li>;
                  })}
                </ul>
              </div>
            </Card>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AnomalyDetail;
